import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { UserModel } from './api/models';
import moment from "moment-timezone";

export class Utils {
  

  // date helpers
  static dateInPastBy(numberOfDays: number): Date {
    var date = new Date();
    date.setDate(date.getDate() - numberOfDays);
    return date;
  }

  static daysToBeginningOfMonth(date?: Date) {
    if (!date) date = new Date();

    return Math.floor(
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(date.getFullYear(), date.getMonth(), 1)) /
        (1000 * 60 * 60 * 24)
    );
  }

  static daysToBeginningOfYear(date?: Date) {
    if (!date) date = new Date();

    return Math.floor(
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(date.getFullYear(), 0, 1)) /
        (1000 * 60 * 60 * 24)
    );
  }

  static formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secsStr = secs.toString().padStart(2, '0');

    return `${hoursStr}:${minutesStr}:${secsStr}`;
  }

  static formatNumberToCommaSeparated(value: any, decimals: number): string {
  if (typeof value === 'string') {
    value = parseInt(value);
  }
  if (value === null || isNaN(value) || typeof value === 'undefined')
    return '-';

  if (decimals != null && typeof (decimals) == 'number' && !isNaN(decimals))
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  else
    decimals = 0;

  var s = value.toFixed(decimals).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  return s;
}
  
  static formatByteSize(value: any): string {
  if (value === null || isNaN(value) || value == 0)
    return '-';

  value = value / 1024;

  if (value < 64)
    return Utils.formatNumberToCommaSeparated(value, 2) + ' KB';

  if (value < 256)
    return Utils.formatNumberToCommaSeparated(value, 1) + ' KB';

  if (value < 1024)
    return Utils.formatNumberToCommaSeparated(value, 0) + ' KB';


  value = value / 1024;

  if (value < 64)
    return Utils.formatNumberToCommaSeparated(value, 2) + ' MB';

  if (value < 256)
    return Utils.formatNumberToCommaSeparated(value, 1) + ' MB';

  if (value < 1024)
    return Utils.formatNumberToCommaSeparated(value, 0) + ' MB';


  value = value / 1024;

  if (value < 64)
    return Utils.formatNumberToCommaSeparated(value, 2) + ' GB';

  if (value < 256)
    return Utils.formatNumberToCommaSeparated(value, 1) + ' GB';

  if (value < 1024)
      return Utils.formatNumberToCommaSeparated(value, 0) + ' GB';

  value = value / 1024;

  if (value < 64)
    return Utils.formatNumberToCommaSeparated(value, 2) + ' TB';

  if (value < 256)
    return Utils.formatNumberToCommaSeparated(value, 1) + ' TB';

  return Utils.formatNumberToCommaSeparated(value, 0) + ' TB';
}


  static formatMountainTime(date: Date | string | undefined | null): string {
    if (!date)
      return '';
    // Convert the local time to Mountain Time with daylight savings check
    const localTime = moment(date);
    const mountainTime = moment(date).tz('America/Denver');

    var localTimeStr = '';
    if (localTime.format('z') != mountainTime.format('z')) {
      let currentTimezone = moment.tz.guess();
      if (!currentTimezone)
        currentTimezone = 'Local';


      localTimeStr = ' (' + currentTimezone + ' ' + localTime.format('h:mm:ss A zz') + ')';
    }

    return mountainTime.format('dddd, MMMM Do, YYYY [at] h:mm:ss A zz') + localTimeStr;
  }


  static convertFromMountainTimeToLocal(date: Date | string | undefined | null): Date | null {
    if (!date)
      return null;
    const mountainTime = moment.tz(date, 'America/Denver');

    var localTime = moment(date).utc().tz(moment.tz.guess() || 'Local');
    
    return localTime.toDate();
  }

  static getTimeFromNow(date: Date): string {
    return moment(date).fromNow();
  }

  static getErrorMessage(validatorName: string, validatorValue: any): string {
    switch (validatorName) {
      case 'required':
        return 'This field is required.';
      case 'minlength':
        return `Minimum length is ${validatorValue.requiredLength}.`;
      case 'maxlength':
        return `Maximum length is ${validatorValue.requiredLength}.`;
      case 'email':
        return `The field shall be a valid email.`;
      // Add more cases for other validators you might have
      default:
        return `Validation failed (${validatorName}).`;
    }
  }

  static getFormErrors(form: FormGroup, parentControlName?: string): string[] {
    var errors: string[] = [];
    if (!form) return errors;
    if (!parentControlName) parentControlName = '';
    for (let controlName in form.controls) {
      let control = form.controls[controlName];
      if (control.status === 'INVALID') {
        let formArray = control as FormArray;
        if (formArray && formArray.controls && formArray.controls.length > 0) {
          for (let subFormName in formArray.controls) {
            errors.push(
              ...Utils.getFormErrors(
                formArray.controls[subFormName] as FormGroup,
                `${parentControlName}${controlName}[${subFormName}].`
              )
            );
          }
        } else {
          for (let validatorName in control.errors) {
            //errorMessages.push(Utils.getErrorMessage(validatorName, control.errors[validatorName]));
            switch (validatorName) {
              case 'required':
                errors.push(
                  `The field "${parentControlName}${controlName}" is required.`
                );
                break;
              case 'minlength':
                errors.push(
                  `The field "${parentControlName}${controlName}" minimum length is ${control.errors[validatorName].requiredLength}.`
                );
                break;
              case 'maxlength':
                errors.push(
                  `The field "${parentControlName}${controlName}" maximum length is ${control.errors[validatorName].requiredLength}.`
                );
                break;
              case 'email':
                errors.push(
                  `The field "${parentControlName}${controlName}" shall be a valid email.`
                );
                break;
              default:
                errors.push(
                  `The field "${parentControlName}${controlName}" is invalid.`
                );
            }
          }
        }
      }
    }
    return errors;
  }

  static getAjaxError(err: any): string {
    var errMsg = 'Error';
    if (typeof err == 'string') errMsg = `${err}`;
    else {
      errMsg =
        err.error && err.error.message ? err.error.message
        : err.error && err.error.Message ? err.error.Message
          : err.errors && err.errors.model && err.errors.model.length ? err.errors.model[0]
          : err.title ? err.title
          : err.message ? err.message
          : err.error ? err.error
          : err.status ? `Error performing request, status code = ${err.status} ${err.statusText}`
                : `${JSON.stringify(err, null, 2) }`;
      if (err.errors) {
        for (var k in err.errors) {
          if (typeof err.errors[k] == 'string') {
            errMsg = err.errors[k];
            break;
          } else if (
            err.errors[k].length &&
            typeof err.errors[k][0] == 'string'
          ) {
            errMsg = err.errors[k][0];
            break;
          }
        }
      }
    }
    return errMsg;
  }

  static getDateFromISODate(dateStr: string): Date {
    const dateSplitted = dateStr.split('-');
    return new Date(
      Number(dateSplitted[0]),
      Number(dateSplitted[1]) - 1,
      Number(dateSplitted[2])
    );
  }

  static getDateFromFormatedDate(dateStr: string): Date {

    var d = moment.tz(dateStr, 'America/Denver');
    console.debug(d);
    return d.local().toDate();

    let i = dateStr.indexOf(' ');
    let timeStr = null;
    if (i > 5) {
      timeStr  = dateStr.substring(i);
      dateStr = dateStr.substring(0, i);
    }
    const dateSplitted = dateStr.split('/');


    var date = new Date(Date.UTC(
      Number(dateSplitted[2]),
      Number(dateSplitted[0]) - 1,
      Number(dateSplitted[1])));
    if (timeStr) {
      var hhOf = 0;
      if (timeStr.indexOf('AM') > 0)
        timeStr = timeStr.replace('AM', '');
      else if (timeStr.indexOf('PM') > 0) {
        timeStr = timeStr.replace('PM', '');
        hhOf = 12;
      }

      const timeSplitted = timeStr.split(':');
      date.setHours(Number(timeSplitted[0]) + hhOf);
      date.setMinutes(Number(timeSplitted[1]));
      date.setSeconds(Number(timeSplitted[2])); 
    }
    return date;
  }
  static deepClone(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  static normalizePrimeDatatableEvent(event: any) {
    var filter = Utils.deepClone(event || { filters: {} });
    if (!filter.filters)
      filter.filters = {};
    for (let key in filter.filters) {
      let value = filter.filters[key];
      if (!value)
        continue;
      if (Array.isArray(value)) {
        filter.filters[key] = value.map((item: any) => ({
          Value: item?.Value ?? item?.value ?? null,
          MatchMode: item?.MatchMode ?? item?.matchMode ?? null,
          Operator: item?.Operator ?? item?.operator ?? null
        }));
        continue;
      }
      let constraints = Array.isArray(value?.constraints) ? value.constraints : (Array.isArray(value?.Constraints) ? value.Constraints : null);
      if (constraints) {
        filter.filters[key] = constraints.map((item: any) => ({
          Value: item?.Value ?? item?.value ?? null,
          MatchMode: item?.MatchMode ?? item?.matchMode ?? value?.MatchMode ?? value?.matchMode ?? null,
          Operator: item?.Operator ?? item?.operator ?? value?.Operator ?? value?.operator ?? null
        }));
        continue;
      }
      filter.filters[key] = [{
        Value: value?.Value ?? value?.value ?? null,
        MatchMode: value?.MatchMode ?? value?.matchMode ?? null,
        Operator: value?.Operator ?? value?.operator ?? null
      }];
    }
    return filter;
  }

  static getCaretPosition(editableDiv: HTMLElement) {
    var caretPos = 0,
      sel: Selection | null,
      range;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel && sel.rangeCount) {
        range = sel.getRangeAt(0);
        if (range.commonAncestorContainer.parentNode == editableDiv) {
          caretPos = range.endOffset;
        }
      }
    } else if (
      (document as any).selection &&
      (document as any).selection.createRange
    ) {
      range = (document as any).selection.createRange();
      if (range.parentElement() == editableDiv) {
        var tempEl = document.createElement('span');
        editableDiv.insertBefore(tempEl, editableDiv.firstChild);
        var tempRange = range.duplicate();
        tempRange.moveToElementText(tempEl);
        tempRange.setEndPoint('EndToEnd', range);
        caretPos = tempRange.text.length;
      }
    }
    return caretPos;
  }

  static addMinutes(date: Date, minutes: number) {
    return new Date(date.getTime() + minutes * 60000);
  }
  static parseJwt(token: string | null | undefined) {
    if (!token) return {};
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  static generatePassword(len: number) {
    var length = len,
      charset =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
      retVal = '';
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
}

declare global {
  interface Date {
    toISODate(): string;
    toSimpleDate(): string;
  }
}

Object.defineProperty(Date.prototype, 'toISODate', {
  value: function () {
    return (
      this.getFullYear() +
      '-' +
      ('0' + (this.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + this.getDate()).slice(-2)
    );
  },
});

Object.defineProperty(Date.prototype, 'toSimpleDate', {
  value: function () {
    return (
      ('0' + (this.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + this.getDate()).slice(-2) +
      '/' +
      this.getFullYear()
    );
  },
});
